module.exports = {
  name: 'GatewayHeaderItem',
  props: ['uid', 'mac', 'data', 'isDisconnected', 'optionCommands'],
  data() {
    return {
      baseCommands: [{
        name: 'delete',
        icon: 'delete',
        color: 'secondary',
        description: 'gateway.delete',
        click: (mac) => this.removeGateway(mac)
      }, {
        name: 'reload',
        icon: 'refresh',
        color: 'primary',
        description: 'gateway.reload',
        click: (mac) => this.reloadGateway(mac)
      }, {
        name: 'reboot',
        icon: 'power_settings_new',
        color: 'red',
        description: 'gateway.reboot',
        click: (mac) => this.rebootGateway(mac)
      }]
    }
  },
  computed: {
    commands() {
      return [...this.baseCommands, ...(this.optionCommands || [])];
    },
    classDisconnected() {
      return {
        'red--text': this.isDisconnected
      };
    }
  },
  methods: {
    async reloadGateway(mac) {
      let ref = this.$db.ref('command').push();
      try {
        await ref.set({
          mac: mac,
          cmd: 'reload'
        });
      } catch (err) {
        this.popup(this.$t('gateway.permission_denied'));
        return;
      }
      this.popup(this.$t('gateway.mac_reloading', {
        mac: mac
      }));

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) this.popup(val);
      });

      let refMac = this.$db.ref('userMac').child(this.uid).child(mac);
      refMac.on('child_changed', snapshot => {
        if (snapshot.key === 'updatedTime') {
          this.popup(this.$t('gateway.mac_up', {
            mac: mac
          }));
        }
      });

      setTimeout(() => {
        refMac.off();
        refErr.off();
      }, 5000);
    },
    async rebootGateway(mac) {
      let ref = this.$db.ref('command').push();
      try {
        await ref.set({
          mac: mac,
          cmd: 'reboot'
        });
      } catch (err) {
        this.popup(this.$t('gateway.permission_denied'));
        return;
      }
      this.popup(this.$t('gateway.mac_rebooting', {
        mac: mac
      }));

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) this.popup(val);
      });

      setTimeout(() => {
        refErr.off();
      }, 5000);
    },
    removeGateway() {
      this.$db.ref('macRemover').child(this.uid).set(this.mac);
      this.popup(this.$t('gateway.mac_removed', {
        mac: this.mac
      }));
    },
    popup(msg) {
      this.$emit('popup', msg);
    }
  },
  template: `
<v-list two-line class="pa-0">
  <v-list-tile :key="mac">
    <v-list-tile-content :class="classDisconnected">
      <template v-if="data.hostname && data.hostname.length>0">
        <v-list-tile-title class="font-weight-bold" >{{ data.hostname }}</v-list-tile-title>
        <v-list-tile-sub-title class="caption">{{ mac }}</v-list-tile-sub-title>
      </template>
      <template v-else>
        <v-list-tile-title class="font-weight-bold" >{{ mac }}</v-list-tile-title>
      </template>
    </v-list-tile-content>
    <v-list-tile-action>
      <div>
        <slot></slot>
        <v-menu class="right-top-menu-btn ml-1">
          <v-btn icon slot="activator">
            <v-icon color="grey">more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="cmd in commands" :key="cmd.name" @click="cmd.click(mac)">
              <v-list-tile-action>
                <v-icon :color="cmd.color">{{ cmd.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ $t(cmd.description) }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-list-tile-action>
  </v-list-tile>
</v-list>
  `
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/GatewayHeaderItem.js
// module id = QwEr
// module chunks = 0